export type BalloonVisualMetrics = {
  width: number;
  height: number;
  fontSize: number;
  maxLines: number;
  mediaWidth: number;
  mediaHeight: number;
  mediaGap: number;
};

const clamp = (value: number, minimum: number, maximum: number) =>
  Math.max(minimum, Math.min(maximum, value));

export function getBalloonVisualMetrics(label: string, hasMedia = false): BalloonVisualMetrics {
  const length = [...label.trim()].length;
  const hasLabel = length > 0;
  const textWidth = clamp(96 + Math.max(0, length - 4) * 7, 96, 280);
  const mediaWidth = hasMedia ? (hasLabel ? (length > 36 ? 86 : length > 20 ? 106 : 132) : 200) : 0;
  const mediaHeight = hasMedia ? (hasLabel ? (length > 36 ? 84 : length > 20 ? 102 : 116) : 150) : 0;
  const mediaGap = hasMedia && hasLabel ? 2 : 0;
  return {
    width: hasMedia
      ? hasLabel
        ? clamp(textWidth + mediaWidth + mediaGap, 218, 350)
        : 184
      : textWidth,
    height: hasMedia
      ? hasLabel
        ? Math.max(140, length > 28 ? 148 : 144)
        : 156
      : length > 28 ? 134 : length > 14 ? 124 : 112,
    fontSize: length > 36 ? 18 : length > 22 ? 20 : length > 12 ? 23 : length > 5 ? 27 : 35,
    maxLines: length > 28 ? 3 : 2,
    mediaWidth,
    mediaHeight,
    mediaGap,
  };
}

export function getWagonQuestionFontSize(prompt: string, wagonWidth: number): number {
  const length = [...prompt.trim()].length;
  const widthFactor = clamp(wagonWidth / 286, 0.55, 1);
  const lengthFactor = length > 70 ? 0.43 : length > 44 ? 0.52 : length > 26 ? 0.64 : length > 14 ? 0.78 : 1;
  return Math.round(clamp(51 * widthFactor * lengthFactor, 18, 51));
}
